import { CHECKOUT_ERROR_CODES, type TCheckoutErrorCode } from '../constants/checkoutErrorCodes'
import { type TCheckoutErrorMessage } from '../types/checkoutTypes'

const CHECKOUT_ERROR_KEYS = {
    prepaidCard: {
        title: 'i18n.checkoutErrorPrepaidCardTitle',
        description: 'i18n.checkoutErrorPrepaidCardDescription',
    },
    cardDeclined: {
        title: 'i18n.checkoutErrorCardPreauthTitle',
        description: 'i18n.checkoutErrorCardPreauthDescription',
    },
    generic: {
        title: 'i18n.checkoutErrorGenericTitle',
        description: 'i18n.checkoutErrorGenericDescription',
    },
} as const

type TCheckoutErrorKeys = (typeof CHECKOUT_ERROR_KEYS)[keyof typeof CHECKOUT_ERROR_KEYS]

export const GENERIC_CHECKOUT_ERROR_KEYS: TCheckoutErrorKeys = CHECKOUT_ERROR_KEYS.generic

const ERROR_KEYS_BY_CODE: Partial<Record<TCheckoutErrorCode, TCheckoutErrorKeys>> = {
    [CHECKOUT_ERROR_CODES.prepaidCard]: CHECKOUT_ERROR_KEYS.prepaidCard,
    [CHECKOUT_ERROR_CODES.cardPreauthFailed]: CHECKOUT_ERROR_KEYS.cardDeclined,
    [CHECKOUT_ERROR_CODES.paymentDeclined]: CHECKOUT_ERROR_KEYS.cardDeclined,
}

export const getCheckoutErrorKeys = (code: TCheckoutErrorCode): TCheckoutErrorKeys | null =>
    ERROR_KEYS_BY_CODE[code] ?? null

export const getCheckoutErrorText = ({ title, description }: TCheckoutErrorMessage): string =>
    `${title} ${description}`
